import { SVGProps, Ref, forwardRef } from 'react'
const SvgShoppingBag = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.252 7.25h7.496a3.75 3.75 0 0 0-7.496 0Zm8.996 0H19A2.75 2.75 0 0 1 21.75 10v10A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20V10A2.75 2.75 0 0 1 5 7.25h1.751a5.25 5.25 0 0 1 10.497 0ZM3.75 10c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25V10Z"
      clipRule="evenodd"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShoppingBag)
export default ForwardRef
